import * as React from 'react';
const SvgReplace = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 2L14 2M4 8.66667L8 4.66667M8 4.66667L12 8.66667M8 4.66667L8 14"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgReplace;
